module.exports = [
    {
        "label": "Nudge with a text message",
        "value": "Nudge with a text message"
    },
    {
        "label": "Offer Package or a Deal",
        "value": "Offer Package or a Deal"
    },
    {
        "label": "Offer a Voucher",
        "value": "Offer a Voucher"
    },
    {
        "label": "Promote Product Service or Activity",
        "value": "Promote Product Service or Activity"
    },
    {
        "label": "Offer Live Chat",
        "value": "Offer Live Chat"
    },
    {
        "label": "Assign Customer Segment",
        "value": "Assign Customer Segment"
    }
]